import { trpc } from '@/shared/api';

export interface ProductSnapshot {
  readonly colorOptionIds: string[];
  /** products.width_mm·height_mm. 둘 중 하나라도 없으면 null. */
  readonly measurement: { readonly widthMm: number; readonly heightMm: number } | null;
}

/** 편집영역 저장 직전, 그 사이 바뀐 색상 추가·삭제와 상품 실측을 확인한다. */
export const useProductSnapshot = (productId: string): (() => Promise<ProductSnapshot>) => {
  const utils = trpc.useUtils();
  return async () => {
    const product = await utils.productManagement.products.get.fetch(
      { id: productId },
      { staleTime: 0 },
    );
    return {
      colorOptionIds: product.colorOptions.map((color) => color.id),
      measurement:
        product.widthMm === null || product.heightMm === null
          ? null
          : { widthMm: product.widthMm, heightMm: product.heightMm },
    };
  };
};
